export default function assert(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}
//# sourceMappingURL=assert.js.map


// WEBPACK FOOTER //
// ./~/@loaders.gl/images/dist/esm/lib/utils/assert.js